import React from 'react'

import { sortActivities } from '@/modules/Activities'
import { useFacilitiesMeta } from '@/modules/Facilities/hooks/useFacilitiesMeta'

export const useSearchActivityOptions = () => {
  const { data } = useFacilitiesMeta()

  return React.useMemo(
    () =>
      sortActivities([...(data?.activities ?? [])]).map((activity) => ({
        label: activity.name,
        value: activity.id,
      })),
    [data?.activities],
  )
}
